var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.graphItems.length > 0)?_c('div',{staticClass:"graph-table-container"},[_c('PieGraphTable',{staticClass:"sidebar-graph-table",attrs:{"id":_vm.id,"items":_vm.graphItems,"show-percentages":true,"story-colour":_vm.storyColour}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }